import React from 'react';
import RoleDefaultAccessContent from '../components/RoleDefaultAccessContent';

/** Matrice accès par rôle — intégré au shell panel v1. */
const PanelRoleDefaultAccessEmbedV1: React.FC = () => (
  <div className="rounded-xl border border-[#223046]/90 bg-[#0e1522]/75 p-4 backdrop-blur-sm">
    <p className="mb-4 text-sm text-cockpit-text-2">
      Définissez les accès par défaut pour chaque rôle. Les comptes héritent de ces réglages ; une surcharge
      individuelle reste prioritaire.
    </p>
    <RoleDefaultAccessContent />
  </div>
);

export default PanelRoleDefaultAccessEmbedV1;
